export enum OrderItems {
  AIRWAY = "airway",
  HOTEL = "hotel",
  ROAD = "road",
  VEHICLE = "vehicle",
  HOTEL_OFFLINE = "offline_hotel",
  ADVANCE = "advance",
  EXPENSE_REPORT = "expense_report",
  EXPENSE = "expense",
}
